/* eslint-disable */
import { StyleSheet , Dimensions } from 'react-native'
import { Fonts } from '../../Themes'
const { width } = Dimensions.get("window")
const screenWidth = width
const itemWidth = (width) / 4
const itemHeight = itemWidth
export default StyleSheet.create({
  container: {
    flex: 1
  },
  text : {
    textAlign: `center`,
    fontSize: 14,
    fontFamily:  Fonts.style.font.bold
  },
  content: {
    backgroundColor: '#FFFFFF',
    justifyContent: 'center',
    alignItems: 'center',
    width: itemWidth,
    height: itemWidth,
    borderColor: Fonts.style.color.baseColor,
    borderWidth: 1
  },
  image: {
    width: 20,
    height: 20
  }
})
